import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import * as React from "react";

type Store = {
  reservationInfo: {
    hosId: string, addPrice: number, date: string, companyId: string, pkgId: string, famId: string, groudPrice: number, time: string
  }
  checkedInjectioList: []
  setCheckedInjectioList: (by: []) => void
  closeItems: []
  setCloseItems: (by: []) => void
  choiceLimitCount: number
  setChoiceLimitCount: (by: number) => void
  pakageInfo: {
    piis: {}, result: {
      id: string, name: string, serviceName: string, companyId: string, hospitalId: string, price: number
    }
  }
  /*  reservationId: string
    setReservationId: (by: string) => void*/
}

const useStore = create<Store>()(
  devtools(
    persist(
      (set) => ({
        reservationInfo: { hosId: '', addPrice: 0, date: '', companyId: '', pkgId: '', famId: '', groudPrice: 0, time: '' },
        setReservationInfo: (name: any, value: any) => set((state: any) => {
          state.reservationInfo[name] = value;
          return {}
        }),
        checkedInjectioList: [],
        setCheckedInjectioList: (by: []) => set((state) => ({ checkedInjectioList: by })),
        closeItems: [],
        setCloseItems: (by: []) => set((state) => ({ closeItems: by })),
        choiceLimitCount: 0,
        setChoiceLimitCount: (by: number) => set((state) => ({ choiceLimitCount: by })),
        pakageInfo: {
          piis: {}, result: {
            id: '', name: '', serviceName: '', companyId: '', hospitalId: '', price: 0
          }
        },
        setPakageInfoPiis: (newPiis: any) =>
          set((state: any) => ({
            pakageInfo: {
              ...state.pakageInfo,
              piis: {
                ...state.pakageInfo.piis,
                ...newPiis,
              },
            },
          })),
        setPakageInfoResult: (newResult: any) =>
          set((state: any) => ({
            pakageInfo: {
              ...state.pakageInfo,
              result: {
                ...state.pakageInfo.result,
                ...newResult,
              },
            },
          })),
        /*  reservationId: '',
          setReservationId: (by: string) => set((state) => ({ reservationId: by })),*/
      }),
      { name: 'reservationStore' },
    ),
  ),
)

export default useStore;